import type { TranslationKeys } from "./en";

export const lv: TranslationKeys = {
  nav: {
    findJobs: "Atrast darbu",
    cvBuilder: "AI CV veidotājs",
    pricing: "Cenas",
    openBot: "Atvērt botu",
    signIn: "Ieiet",
    signOut: "Iziet",
    adminDashboard: "Admina panelis",
    admin: "Admins",
    pricingAndPlans: "Cenas un plāni",
    theme: "Tēma",
    themeDark: "Tumšā",
    themeLight: "Gaišā",
    themeSystem: "Sistēmas",
    support: "Atbalsts",
    donate: "Atbalstīt izstrādātāju",
  },
  hero: {
    badge: "AI atlase reāllaikā",
    badgeFocus: "Worldwide",
    title: "Jūsu AI karjeras asistents",
    titleHighlight: "Telegram",
    subtitle: "200+ komandas. AI rīki CV. Reāllaika vakances no 4 avotiem. Tūlītēji paziņojumi. Viss Telegram — bez lietotnēm.",
    cta: "Atvērt Telegram",
    ctaPro: "Uzlabot uz PRO",
    leadMagnet: 'Bezmaksas ceļvedis: "Kā atrast attālināto darbu 14 dienās"',
    statCommands: "Bota komandas",
    statSources: "Avoti",
    statAlerts: "Paziņojumi",
    statCV: "CV un Karjera",
  },
  features: {
    title: "Viss, kas vajadzīgs, lai",
    titleHighlight: "Atrastu sapņu darbu",
    subtitle: "Balstīts uz AI, veidots attālinātiem darbiniekiem visā pasaulē.",
    aiJobSearch: "AI Darba meklēšana",
    aiJobSearchDesc: "Reāllaika apkopojums no 100+ avotiem. Attālinātas vakances visā pasaulē.",
    smartMatching: "Viedais atlasītājs",
    smartMatchingDesc: "AI analizē jūsu profilu, prasmes un vēsturi, lai atrastu ideālas vakances.",
    aiDiagnostics: "AI Diagnostika",
    aiDiagnosticsDesc: "Detalizēta CV kvalitātes, konkurētspējas un tirgus atbilstības analīze.",
    aiCVFix: "AI CV labošana",
    aiCVFixDesc: "Automātiski uzlabojumi, ATS optimizācija un pielāgošana vakancei.",
    cvGenerator: "CV ģenerators",
    cvGeneratorDesc: "Izveidojiet CV no nulles. EN, LV, RU atbalsts ar PDF/DOCX eksportu.",
    euFocus: "Globālais fokuss",
    euFocusDesc: "Specializēti filtri darba atļaujām, valodām un reģionālām prasībām.",
    realtime: "Reāllaika atjauninājumi",
    realtimeDesc: "Dzīvā vakanču plūsma ar tūlītējiem paziņojumiem. Nepalaidiet garām iespēju.",
    privacy: "Privātums vispirms",
    privacyDesc: "Jūsu dati ir drošībā. Nav nepieciešami maksas AI kredīti — pilnībā atvērtais kods.",
  },
  howItWorks: {
    title: "Kā",
    titleBrand: "RemoteAI",
    titleEnd: "darbojas",
    subtitle: "No Telegram līdz sapņu darbam 4 vienkāršos soļos",
    step1Title: "Atveriet Telegram botu",
    step1Desc: "Palaidiet @RemoteJobsCV_bot Telegram. Reģistrācija nav nepieciešama — vienkārši nospiediet Start.",
    step2Title: "Meklējiet un filtrējiet",
    step2Desc: "Izmantojiet /jobs, /search vai 50+ komandas, lai atrastu ideālas attālinātās pozīcijas.",
    step3Title: "AI Karjeras rīki",
    step3Desc: "AI CV analīze, motivācijas vēstules, intervijas sagatavošana — viss Telegram.",
    step4Title: "Iestatiet paziņojumus",
    step4Desc: "Izveidojiet /newalert tūlītējiem paziņojumiem. Uzlabojiet uz PRO neierobežotai piekļuvei.",
  },
  cta: {
    badge: "100% Bezmaksas sākumam",
    title: "Sāciet saņemt vakances Telegram tagad",
    subtitle: "Pievienojieties tūkstošiem profesionāļu visā pasaulē. Vienkārši atveriet botu, ierakstiet /jobs — un esat klāt.",
    openBot: "Atvērt Telegram botu",
    upgradePro: "Uzlabot uz PRO",
  },
  footer: {
    description: "Nr. 1 AI vadītā attālinātā darba platforma. Atrodiet sapņu darbu ar inteliģentu atlasi.",
    product: "Produkts",
    resources: "Resursi",
    company: "Uzņēmums",
    findJobs: "Atrast darbu",
    cvBuilder: "CV veidotājs",
    aiDiagnostics: "AI Diagnostika",
    pricing: "Cenas",
    careerTips: "Karjeras padomi",
    interviewGuide: "Intervijas ceļvedis",
    cvTemplates: "CV veidnes",
    blog: "Emuārs",
    aboutUs: "Par mums",
    supportDeveloper: "Atbalstīt izstrādātāju",
    privacyPolicy: "Privātuma politika",
    termsOfService: "Lietošanas noteikumi",
    supportTitle: "Atbalstīt izstrādātāju",
    supportDesc: "Palīdziet RemoteAI palikt bezmaksas",
    copied: "Nokopēts!",
    copyBTC: "Kopēt BTC",
    learnMore: "Apmeklēt atbalsta lapu",
    copyright: "© 2024 RemoteAI. Visas tiesības aizsargātas.",
    madeFor: "Veidots visiem",
  },
  jobs: {
    title: "Atrodiet savu",
    titleHighlight: "Attālināto sapņu darbu",
    subtitle: "Reāllaika apkopojums no",
    searchPlaceholder: "Amats, prasmes vai uzņēmums...",
    refresh: "Atjaunināt",
    search: "Meklēt",
    region: "Reģions:",
    source: "Avots:",
    allLocations: "Visi reģioni",
    latvia: "Latvija 🇱🇻",
    eu: "ES 🇪🇺",
    worldwide: "Pasaule 🌍",
    allSources: "Visi avoti",
    latestJobs: "Jaunākās attālinātās vakances",
    fetchingJobs: "Ielādē vakances...",
    jobsFound: "vakances atrastas",
    showing: "Rāda",
    of: "no",
    jobs: "vakancēm",
    loading: "Ielādē...",
    live: "Tiešsaistē",
    fetchingMultiple: "Ielādē vakances no vairākiem avotiem...",
    noJobsFound: "Vakances nav atrastas",
    noJobsDesc: "Mēģiniet mainīt filtrus vai meklēšanas vaicājumu.",
    freePlan: "Jūs esat BEZMAKSAS plānā",
    freeDesc: "Rāda {cap} no {total} vakancēm. Uzlabojiet, lai redzētu visas.",
    upgradePro: "Uzlabot PRO — $9.99/mēn",
    openBot: "Atvērt botu",
    allJobs: "Visas vakances",
    aiCVTools: "AI CV rīki",
    instantAlerts: "Tūlītēji paziņojumi",
    smartMatching: "Viedā atlase",
    apply: "Pieteikties",
    prev: "Iepr.",
    next: "Nāk.",
    page: "Lapa",
  },
  auth: {
    signIn: "Ieiet",
    signUp: "Reģistrēties",
    welcomeBack: "Laipni lūdzam atpakaļ! Piesakieties savā kontā.",
    createAccount: "Izveidojiet kontu, lai sāktu darba meklēšanu.",
    email: "E-pasts",
    password: "Parole",
    fullName: "Pilns vārds",
    signingIn: "Piesakāmies...",
    creatingAccount: "Veidojam kontu...",
    forgotPassword: "Aizmirsāt paroli?",
    resetPassword: "Atiestatīt paroli",
    resetDescription: "Ievadiet e-pastu un mēs nosūtīsim saiti paroles atiestatīšanai.",
    sendResetLink: "Nosūtīt saiti",
    sending: "Sūta...",
    cancel: "Atcelt",
    terms: "Turpinot, jūs piekrītat Lietošanas noteikumiem un Privātuma politikai.",
    missingFields: "Nav aizpildīti lauki",
    fillRequired: "Lūdzu, aizpildiet visus obligātos laukus",
    enterEmailPassword: "Ievadiet e-pastu un paroli",
    accountExists: "Konts pastāv",
    accountExistsDesc: "Šis e-pasts jau ir reģistrēts. Lūdzu, piesakieties.",
    accountCreated: "Konts izveidots!",
    accountCreatedDesc: "Tagad varat piesakīties savā kontā.",
    signUpFailed: "Reģistrācijas kļūda",
    invalidCredentials: "Nepareizi dati",
    invalidCredentialsDesc: "Pārbaudiet e-pastu un paroli",
    welcomeBackToast: "Laipni lūdzam!",
    signedIn: "Jūs esat veiksmīgi pierakstījušies.",
    signInFailed: "Pieteikšanās kļūda",
    emailRequired: "Nepieciešams e-pasts",
    emailRequiredDesc: "Lūdzu, vispirms ievadiet e-pastu.",
    checkEmail: "Pārbaudiet e-pastu",
    checkEmailDesc: "Paroles atiestatīšanas saite nosūtīta uz jūsu e-pastu.",
    resetFailed: "Atiestatīšanas kļūda",
    somethingWrong: "Kaut kas nogāja greizi",
  },
  pricing: {
    badge: "Vienkāršas cenas",
    title: "Izvēlieties savu",
    titleHighlight: "Plānu",
    subtitle: "Sāciet bezmaksas Telegram. Maksājiet ar USDT (TRC20) tūlītējai aktivācijai — bez KYC, zemākās komisijas.",
    free: "Bezmaksas",
    freePrice: "$0",
    forever: "mūžīgi",
    freeDesc: "Sāciet caur Telegram",
    proMonthly: "Pro Mēnesis",
    proMonthlyPrice: "$9.99",
    perMonth: "/mēnesī",
    proMonthlyDesc: "Atbloķējiet visas AI funkcijas",
    proYearly: "Pro Gads",
    proYearlyPrice: "$79.99",
    perYear: "/gadā",
    proYearlyDesc: "Ietaupiet 33% — labākā cena",
    mostPopular: "Populārākais",
    startFree: "Sākt bezmaksas Telegram",
    payUSDT: "Maksāt ar USDT",
    payYearly: "Maksāt par gadu USDT",
    features: {
      threeResults: "3 rezultāti meklēšanā",
      basicSearch: "Pamata meklēšanas komandas",
      browseAll: "Visi avoti",
      communitySupport: "Kopienas atbalsts",
      unlimitedResults: "Neierobežoti rezultāti",
      advancedFilters: "Paplašināti filtri un saglabātas meklēšanas",
      aiCVAnalysis: "AI CV analīze un pārrakstīšana",
      aiCoverLetter: "AI Motivācijas vēstuļu ģenerators",
      instantAlerts: "Tūlītēji vakanču paziņojumi",
      atsChecker: "ATS Score pārbaudītājs",
      multiLangCV: "Daudzvalodu CV (EN/LV/RU)",
      prioritySupport: "Prioritāra atbalsts",
      everythingPro: "Viss no Pro Mēnesis",
      saveYearly: "Ietaupiet $39.89 gadā",
      twelveMonths: "12 mēneši pilnas piekļuves",
      earlyAccess: "Agrīna piekļuve jaunām funkcijām",
    },
    notIncluded: {
      advancedFilters: "Paplašināti filtri",
      aiCVTools: "AI CV rīki",
      instantAlerts: "Tūlītēji paziņojumi",
      unlimitedResults: "Neierobežoti rezultāti",
    },
    referralTitle: "Uzaiciniet draugus — iegūstiet PRO bezmaksas",
    referralDesc: "Uzaiciniet 3 draugus botā → saņemiet 7 dienas PRO bezmaksas! Izmantojiet",
    referralEnd: "botā, lai saņemtu savu unikālo saiti.",
    usdtTitle: "Maksāt ar USDT (TRC20)",
    usdtDesc: "Mēs pieņemam <b>USDT uz TRON (TRC20)</b> kā galveno maksājuma metodi. Zemākās komisijas, ātri apstiprinājumi un <b>automātiska verifikācija</b> — TX hash nav nepieciešams.",
    signInRequired: "Nepieciešama pieteikšanās",
    signInRequiredDesc: "Lūdzu, piesakieties, lai veiktu maksājumu.",
    copiedToClipboard: "Nokopēts starpliktuvē",
    plan: "Plāns",
    amount: "Summa",
    copy: "Kopēt",
    network: "Tīkls",
    sendTo: "Nosūtīt USDT uz:",
    loadingWallet: "Ielādē maka adresi...",
    warningNetwork: "⚠️ Sūtiet TIKAI caur TRON (TRC20) tīklu. Sūtīšana caur citu tīklu izraisīs līdzekļu zaudēšanu.",
    autoVerified: "✅ <b>Auto-verificēts!</b> Pēc precīzas summas nosūtīšanas jūsu maksājums tiks atklāts un apstiprināts automātiski 2 minūšu laikā. TX hash nav nepieciešams.",
    openBotStatus: "Atvērt botu statusa pārbaudei",
  },
  cvBuilder: {
    badge: "AI CV ģenerators",
    title: "Izveidojiet savu",
    titleHighlight: "Ideālo CV",
    titleEnd: "ar AI",
    subtitle: "Veidojiet, optimizējiet un eksportējiet profesionālus CV ES attālinātā darba tirgum. ATS optimizācija un daudzvalodu atbalsts.",
    aiGeneration: "AI Ģenerācija",
    atsOptimized: "ATS-Optimizēts",
    langSupport: "EN, LV, RU atbalsts",
    copyExport: "Kopēšana un eksports",
    step1: "Augšupielāde vai izveide",
    step1Desc: "Sāciet no nulles vai augšupielādējiet esošo CV",
    step2: "AI uzlabošana",
    step2Desc: "AI analizē un uzlabo jūsu CV",
    step3: "Pārskatīšana un rediģēšana",
    step3Desc: "Precizējiet rezultātus",
    step4: "Eksports",
    step4Desc: "Lejupielādējiet vēlamajā formātā",
    yourOptimizedCV: "Jūsu optimizētais CV",
    aiEnhanced: "AI uzlabots un gatavs ATS",
    copyBtn: "Kopēt",
    pdf: "PDF",
    startOver: "Sākt no sākuma",
    howToStart: "Kā vēlaties sākt?",
    uploadExisting: "Augšupielādēt esošo CV",
    uploadExistingDesc: "Augšupielādējiet TXT failu vai ielīmējiet tekstu — AI to pilnībā pārvērtīs.",
    createFromScratch: "Izveidot no nulles",
    createFromScratchDesc: "Pastāstiet par savu pieredzi un prasmēm — AI izveidos profesionālu CV.",
    tellAboutYourself: "Pastāstiet par sevi",
    fullName: "Pilns vārds",
    desiredPosition: "Vēlamā pozīcija",
    professionalSummary: "Profesionālais kopsavilkums",
    professionalSummaryPlaceholder: "Īsi aprakstiet profesionālo pieredzi, galvenās prasmes un ko meklējat...",
    workExperience: "Darba pieredze",
    workExperiencePlaceholder: "Uzskaitiet atbilstošo darba pieredzi. AI palīdzēs formatēt...",
    skillsAndTech: "Prasmes un tehnoloģijas",
    skillsPlaceholder: "Uzskaitiet tehniskās prasmes, soft skills, valodas, sertifikātus...",
    generating: "Ģenerē...",
    generateAICV: "Ģenerēt AI CV",
    atsOptimizedCV: "Tiks izveidots ATS-optimizēts CV",
    uploadYourCV: "Augšupielādējiet savu CV",
    back: "← Atpakaļ",
    notEnoughContent: "Nepietiekami daudz satura",
    notEnoughContentDesc: "Lūdzu, pievienojiet vairāk detaļu (vismaz 50 rakstzīmes).",
    cvGenerated: "CV izveidots!",
    cvGeneratedDesc: "Jūsu optimizētais CV ir gatavs.",
    generationFailed: "Ģenerēšanas kļūda",
    copied: "Nokopēts!",
    copiedDesc: "CV nokopēts starpliktuvē",
    failedCopy: "Kopēšanas kļūda",
    downloaded: "Lejupielādēts!",
    downloadedDesc: "CV saglabāts kā PDF.",
    pdfFailed: "PDF eksporta kļūda",
    fileLoaded: "Fails ielādēts!",
    fileLoadedDesc: "Jūsu CV teksts ir ielādēts.",
    unsupportedFormat: "Neatbalstīts formāts",
    unsupportedFormatDesc: "Lūdzu, augšupielādējiet TXT failu vai ielīmējiet CV tekstu.",
  },
  diagnostics: {
    badge: "AI CV analīze",
    title: "Iegūstiet savu",
    titleHighlight: "CV diagnostiku",
    subtitle: "Reāla AI analīze par CV kvalitāti, ATS saderību un personalizēti uzlabošanas padomi.",
    uploadCV: "Augšupielādējiet savu CV",
    clickToUpload: "Noklikšķiniet, lai augšupielādētu vai velciet",
    txtRecommended: "Ieteicams TXT formāts",
    orPaste: "Vai ielīmējiet tekstu",
    pasteCV: "Ielīmējiet savu CV",
    pastePlaceholder: "Ielīmējiet CV saturu šeit... Iekļaujiet pieredzi, prasmes, izglītību un sasniegumus.",
    uploadInstead: "Augšupielādēt failu",
    characters: "rakstzīmes",
    minChars: "Minimums 100 rakstzīmes",
    analyzingAI: "AI analizē...",
    analyzeCV: "Analizēt CV",
    atsScoring: "ATS vērtējums",
    atsDesc: "ATS saderības pārbaude",
    keywordAnalysis: "Atslēgvārdu analīze",
    keywordDesc: "Trūkstošie atslēgvārdi",
    marketFit: "Tirgus atbilstība",
    marketFitDesc: "ES darba tirgus atbilstība",
    aiRecommendations: "AI Ieteikumi",
    aiRecommendationsDesc: "Personalizēti padomi",
    overallScore: "Kopējais ATS vērtējums",
    outOf100: "no 100",
    analyzeAnother: "Analizēt citu CV",
    strengths: "Stiprās puses",
    areasToImprove: "Uzlabojamās jomas",
    personalizedImprovements: "Personalizēti uzlabojumi",
    missingKeywords: "Trūkstošie atslēgvārdi",
    aiAutoFix: "AI Auto-labošana",
    aiAutoFixDesc: "AI pārrakstīs CV ar visiem uzlabojumiem",
    rewriting: "Pārraksta...",
    fixMyCV: "Labot CV ar AI",
    rewrittenCV: "Pārrakstītais CV",
    rewrittenCVDesc: "Jūsu optimizētā versija",
    cvTooShort: "CV pārāk īss",
    cvTooShortDesc: "Lūdzu, pievienojiet vairāk satura analīzei.",
    analysisComplete: "Analīze pabeigta!",
    analysisCompleteDesc: "Jūsu CV ir analizēts ar AI.",
    analysisFailed: "Analīzes kļūda",
    rateLimited: "Ierobežojums pārsniegts",
    rateLimitedDesc: "Pārāk daudz pieprasījumu. Mēģiniet vēlāk.",
    creditsRequired: "Nepieciešami kredīti",
    creditsRequiredDesc: "Nepieciešami AI kredīti. Sazinieties ar atbalstu.",
    rewriteComplete: "CV pārrakstīts!",
    rewriteCompleteDesc: "Jūsu optimizētais CV ir gatavs.",
    rewriteFailed: "Pārrakstīšanas kļūda",
  },
  savedJobs: {
    title: "Saglabātās",
    titleHighlight: "Vakances",
    subtitle: "Jūsu grāmatzīmes vienuviet.",
    signInToView: "Piesakieties, lai skatītu saglabātās vakances",
    signInDesc: "Izveidojiet kontu vai piesakieties, lai saglabātu vakances.",
    signIn: "Ieiet",
    noSavedJobs: "Nav saglabātu vakanču",
    noSavedJobsDesc: "Pārlūkojiet vakances un noklikšķiniet sirds ikonu, lai saglabātu.",
    browseJobs: "Skatīt vakances",
    savedJob: "Saglabātā vakance",
    savedJobs: "Saglabātās vakances",
    browseMore: "Vairāk vakanču",
    saved: "Saglabāts",
    apply: "Pieteikties",
  },
  support: {
    title: "Atbalstiet",
    titleHighlight: "Izstrādātāju",
    subtitle: "Palīdziet RemoteAI palikt bezmaksas un neatkarīgam. Jūsu atbalsts nozīmē visu! 🙏",
    missionTitle: "🎯 Mūsu misija",
    missionP1: "RemoteAI tika izveidots, lai palīdzētu cilvēkiem visā pasaulē atrast kvalitatīvu attālināto darbu bez trokšņa un surogātpasta. Mēs izmantojam AI, lai atrastu atbilstošas vakances un palīdzētu izveidot konkurētspējīgu CV.",
    missionP2: "Šo projektu izstrādā un uztur neatkarīgs izstrādātājs. Jūsu ziedojumi sedz serveru izmaksas, API maksu un ļauj turpināt jaunu funkciju izstrādi.",
    btcTitle: "Ziedot Bitcoin",
    btcDesc: "Privātuma saudzējoši ziedojumi. Bez kontiem, bez izsekošanas.",
    btcThankYou: "Katrs satoši palīdz! Paldies par atvērtā koda izstrādes atbalstu.",
    otherWays: "Citi veidi, kā palīdzēt",
    shareTwitter: "Dalīties Twitter",
    starGithub: "Zvaigzne GitHub",
    tellFriend: "Pastāstīt draugam",
  },
  notFound: {
    title: "404",
    message: "Ups! Lapa nav atrasta",
    goHome: "Atgriezties sākumā",
  },
  checkout: {
    complete: "Maksājums veikts",
    thankYou: "Paldies par uzlabošanu. Jūsu PRO piekļuve tiek aktivizēta un būs pieejama pēc brīža.",
    reference: "Atsauce:",
    noSession: "Sesijas informācija nav atrasta.",
    browseProJobs: "Skatīt PRO darbus",
    backToPricing: "Atpakaļ uz cenām",
  },
  common: {
    sub_complete: "Pabeigt abonementu",
    close: "Aizvērt",
    havePromo: "Vai ir promo kods?",
    inviteFriends: "Uzaiciniet draugus — saņemiet PRO bez maksas",
    inviteDesc: "Uzaiciniet 3 draugus uz botu → saņemiet 7 dienas PRO bez maksas! Izmantojiet",
    inviteEnd: "botā, lai saņemtu savu unikālo saiti.",
    mostPopular: "Populārākais",
    signInRequired: "Nepieciešama pieteikšanās",
    signInRequiredSubscribe: "Lūdzu, piesakieties, lai abonētu.",
    current: "Pašreizējais plāns",
    cancels: "Atceļas",
    renews: "Atjaunojas",
    on: "—",
    proActive: "PRO ir aktīvs",
    manageBilling: "Pārvaldīt rēķinus",
    opening: "Atver...",
    billingError: "Neizdevās atvērt norēķinu portālu",
    chooseTitle: "Izvēlies savu",
    plan: "Plāns",
    badge: "Vienkāršas cenas",
    subtitle: "Sāciet bez maksas Telegram. Uzlabojiet ar karti tūlītējai aktivizēšanai. Atcelt jebkurā laikā.",
  },
  langSwitcher: {
    en: "English",
    ru: "Русский",
    lv: "Latviešu",
  },
};

